<template>
  <el-dialog :title="$t('114')" :visible.sync="visible" width="600px" :before-close="handleClose">
    <div class="holiday-model">
      <span class="select—time-title">{{ $t('837') }}</span>
      <el-select v-model="form.year_at" :placeholder="$t('838')" @change="handlerChangeYear">
        <el-option v-for="item in yearPptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <!-- 正文 table -->
      <el-table ref="tableref" :data="tableData" border style="margin-top: 20px">
        <el-table-column :label="$t('307')" prop="label">
          <template slot-scope="scope">
            <el-date-picker
              :ref="'date-picker' + scope.$index"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              v-model="scope.row.start"
              type="date"
              :placeholder="$t('878')"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('70')" width="200">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="handleraddData(scope.$index)"
              style="margin-right: 20px"
              >{{ $t('635') }}</el-link
            >
            <el-link
              type="danger"
              :underline="false"
              @click="handlerDeleteData(scope.$index)"
              v-if="tableData.length > 1"
              :disabled="scope.row.isDisabled"
              >{{ $t('65') }}</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('66') }}</el-button>
      <el-button type="primary" :disabled="saveDisabled" plain @click="savePhday">{{ $t('131') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { savePhday, getPhday } from 'api/Attendance'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const self = this
    const year = JSON.stringify(new Date().getFullYear())
    const yearPptions = []
    for (let i = 0; i < 10; i++) {
      yearPptions.push({
        label: Number(year) + i + '',
        value: Number(year) + i + ''
      })
    }
    return {
      // 用户当前日期
      date: new Date(),
      // 存储时使用的参数
      form: {
        date_list: [],
        year_at: year
      },
      dateList: [],
      tableData: [{}],
      // 日期选择控制器
      pickerOptions: {
        /**
         *  日期选择器可选范围
         *  1. 年份必须为上边年份选择器的年份
         *  2. 日期必须大于当前日期（使用时的时间）
         */
        disabledDate: date =>
          Number(self.form.year_at) !== date.getFullYear() || date.getTime() <= this.$util.getTime(-1)
      },
      yearPptions
    }
  },
  computed: {
    saveDisabled: vm => !vm.tableData.filter(v => v.start).length,
    // form.year_at 的年份 跟 当前年份 对比
    isCurYear: vm => Number(vm.form.year_at) === new Date().getFullYear()
  },
  watch: {
    visible(v) {
      if (v) {
        this.getPhday()
        this.init()
      }
    },
    // 在当前年 历史假期不能删除，要置灰
    tableData: {
      handler(arr) {
        if (this.isCurYear) arr.forEach(v => (v.isDisabled = new Date(v.start) <= this.$util.getTime(-1)))
      }
    }
  },
  methods: {
    init() {
      this.form = {
        date_list: [],
        year_at: JSON.stringify(new Date().getFullYear())
      }
      this.tableData = []
    },
    // 关闭dialog
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 添加数据
    handleraddData(index) {
      const item = this.isCurYear ? {} : { start: this.form.year_at + '-01-01' }
      this.tableData.insert(index + 1, item)
    },
    // 获取日期
    getPhday() {
      const msg = { year_at: this.form.year_at }
      getPhday(msg).then(res => {
        this.tableData = res.data.map(item => ({ start: item }))
        if (this.tableData.length < 1) this.tableData = [{ start: this.form.year_at + '-01-01' }]
      })
    },
    // 保存假期
    savePhday() {
      this.form.date_list = this.tableData.map(item => item.start)
      if ([...new Set(this.form.date_list)].length === this.tableData.length) {
        savePhday(this.form).then(() => {
          this.init()
          this.$emit('update:visible', false)
        })
      } else {
        this.$confirm(this.$t('1700'), this.$t('229'), {
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          type: 'warning'
        })
          .then(() => {
            savePhday(this.form).then(() => {
              this.init()
              this.$emit('update:visible', false)
            })
          })
          .catch(() => {})
      }
    },
    // 切换年
    handlerChangeYear() {
      this.getPhday()
    },
    handlerDeleteData(index) {
      this.tableData.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.select—time-title {
  display: inline-block;
  margin-right: 15px;
}
/deep/ .el-icon-circle-plus {
  font-size: 20px;
}
/deep/ .el-icon-remove-outline {
  font-size: 20px;
}
</style>
